module.exports = __webpack_public_path__ + "static/media/img_sendero.f6ffecaf.jpg";